/*
 * Normalizing browser the two events 'orientationchange' and 'resize'.
 * We call this new event a 'size' event.
 *
 * So this is an abstraction around device rotation and resizing which
 * can both fire with varying degress of success depending on the browser.
 *
 * Read:
 * http://stackoverflow.com/questions/23996726/will-window-resize-fire-on-orientation-change
 * https://davidwalsh.name/orientation-change
 *
 */

export const callbacks: Function[] = [];
let timer: number;

// Mobile browsers are slow at animating orientationChange so we've scaled it
// to them because they're slower than desktop browsers (on average).
// Feel free to change this but please test on mobile.
// This is about 60 milliseconds or 4 frames of 60fps animation that we'll wait for...
const waitBetweenDuplicateEvents = 1000 / 15;

const dispatchEvents = () => {
  callbacks.forEach(callback => {
    window.setTimeout(callback, 0);
  });
};

export const onChange = () => {
  // Called from both resize/orientation events
  // So we wait for eventSpeedMilliseconds to see if there's a subsequent
  // event and then we eventually fire the callback in dispatchEvents.
  // exported so that we can trigger events
  if (timer) window.clearTimeout(timer);
  timer = window.setTimeout(dispatchEvents, waitBetweenDuplicateEvents);
};

export const addEventListenerSizeChange = (callback: () => void) => {
  if (callbacks.length === 0) {
    window.addEventListener('orientationchange', onChange);
    window.addEventListener('resize', onChange);
  }
  callbacks.push(callback);
};

export const removeEventListenerSizeChange = (callback: () => void) => {
  const index = callbacks.indexOf(callback);
  if (index > -1) {
    callbacks.splice(index, 1);
  }
};
